<template>
  <div>
    <!-- AQUI -->
    <v-btn
      :disabled="
        medicines_check.length == 0 || time != check_time || countSeparated > 0
      "
      class="btn-modern btn-modern-info mr-2"
      @click="handleOpenModal"
    >
      <i class="fas fa-check-square mr-2 text-twenty"></i>
      CHECAR SELECIONADOS</v-btn
    >
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalCheckedSelected_${check_time}`"
      title="CHECAR"
    >
      <div class="row">
        <div
          v-if="step == 1"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <label>DATA DE REGISTRO</label>
              <input
                disabled
                :value="formatDate(moment().format('YYYY-MM-DD'), false)"
                class="form-control"
              />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <label>HORÁRIO</label>
              <input
                disabled
                :value="
                  prescription_medicine_time.time
                    ? String(prescription_medicine_time.time).substr(0, 5)
                    : 'EVENTUAL'
                "
                class="form-control"
              />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <v-btn
                outlined
                :class="[
                  'btn-block m-1',
                  !checked && '',
                  checked != 'NAO' && '',
                  checked == 'NAO' && 'btn-atrasado',
                ]"
                @click="handleNotDone"
              >
                <i class="fas fa-times mr-1"></i>
                NÃO REALIZADO</v-btn
              >
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <v-btn
                :disabled="!medicine_check.separate_checked"
                outlined
                :class="[
                  'btn-block m-1',
                  !checked && '',
                  checked != 'SIM' && '',
                  checked == 'SIM' && 'btn-checado',
                ]"
                @click="handleDone"
              >
                <i class="fas fa-check mr-2 text-twenty"></i>
                REALIZADO</v-btn
              >
            </div>
            <div
              v-if="medicines.length > 0"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean"
            >
              <small class="col-md-12 m-0 p-0">
                Estoque do(s) medicamento(s) separados!
              </small>
              <hr />
              <div class="row m-0">
                <div
                  class="col-md-12 p-0 m-0 border-bottom pb-2 mb-2"
                  v-for="(item, key) in medicines"
                  :key="key"
                >
                  <p class="c-default m-0 p-0">{{ item.stock.name }}</p>
                  <p class="m-0 p-0">{{ item.stock.stock_owner }}</p>
                </div>
              </div>
            </div>
            <div
              v-show="checked == 'NAO'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <label>OBSERVAÇÃO</label>
              <ChromeSpeechToTextTextarea
                rows="4"
                max-rows="10"
                v-model="note"
              />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>
        <div
          v-if="step == 2"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <div class="row">
            <div
              v-show="checked == 'NAO' && medicine_check.separate_checked"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean"
            >
              <b-form-group label="MEDICAMENTO DESPREZADO?">
                <b-form-radio
                  v-model="despised"
                  name="some-radios"
                  :value="true"
                  >Sim - Baixa no estoque</b-form-radio
                >
                <b-form-radio
                  v-model="despised"
                  name="some-radios"
                  :value="false"
                  >Não - Não baixa no estoque</b-form-radio
                >
              </b-form-group>
            </div>
          </div>
        </div>
        <div
          v-if="step == 2 && show_justification"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
        >
          JUSTIFICATIVA DA CHECAGEM COM ATRASO
          <ChromeSpeechToTextTextarea
            rows="4"
            max-rows="10"
            v-model="justification"
          />
        </div>
        <div
          v-if="step == 2"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center back-ground-grey"
        >
          <h6 class="mb-0">FINALIZAR</h6>
          <div class="mt-1"><ErrorsMessages :errors="errors" /></div>
        </div>
        <div
          v-if="step == 2"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <v-btn
            :disabled="loading"
            @click="handleNext"
            class="btn-notcertified"
          >
            <i class="fas fa-check mr-2 text-twenty"></i>
            FINALIZAR MANUAL
            {{ loading ? "CARREGANDO" : "COM ASSINATURA ELETRÔNICA" }}
          </v-btn>
          <!-- <v-btn :disabled="loading" @click="handleSerasa" class="btn-save">{{
        loading ? "CARREGANDO" : "COM ASSINATURA ELETRÔNICA"
      }}</v-btn> -->
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between"
        >
          <v-btn :disabled="step == 1" @click="handlePrev" class="btn-return">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar</v-btn
          >
          <v-btn
            v-if="step == 1"
            :disabled="loading"
            @click="handleNext"
            class="btn-modern btn-modern-save"
          >
            {{ loading ? "CARREGANDO" : "AVANÇAR" }}
            <i class="fas fa-arrow-right ml-2 text-twenty"></i
          ></v-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import {
  formatDate,
  formatDateOnlyNumbers,
  numbersOnly,
} from "../../../../lib/format";

import { userData } from "../../../../lib/functions";

import moment from "moment";

import routes from "../../../../routes";

export default {
  name: "CheckSelected",
  components: { ErrorsMessages, ChromeSpeechToTextTextarea },
  props: {
    date: [String, Number],
    check_time: [String, Number],
    time: [String, Number],
    medicines_check: Array,
  },
  data() {
    return {
      prescription_medicine_time: {},
      medicine_check: {},
      rest_home_id: "",
      resident_id: "",
      stock_id: "",
      note: "",
      loading: false,
      checked: false,
      despised: false,
      show_justification: false,
      justification: "",
      step: 1,
      countSeparated: 0,
      errors: [],
      enough_stocks: [],
      stocksByMedicine: [],
      stocksResidentByMedicine: [],
      // Migrado para o estoque novo
      stock_group: [],
      medicines: [],
    };
  },
  watch: {
    medicines_check: function () {
      this.retrieve();
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatDate,
    numbersOnly,
    async handleOpenModal() {
      let { medicines_check } = this;

      let { medicine_check, prescription_medicine_time } = medicines_check[0];

      this.medicine_check = medicine_check;

      this.prescription_medicine_time = prescription_medicine_time;
      this.medicine_check = medicine_check;

      this.stock_id = medicine_check.separate_stock_id;
      this.note = medicine_check.note;

      if (!medicine_check.separate_checked) {
        this.checked = "NAO";
      }

      this.$bvModal.show(`modalCheckedSelected_${this.check_time}`);

      await this.getStocksByMedicine();
    },
    retrieve() {
      this.countSeparated = 0;
      this.show_justification = false;

      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { time, medicines_check, date } = this;

      for (let item of medicines_check) {
        if (
          numbersOnly(item.prescription_medicine_time.time) == numbersOnly(time)
        ) {
          if (!item.medicine_check.status) {
            this.countSeparated = this.countSeparated + 1;
          }
        }
      }

      if (
        parseInt(formatDateOnlyNumbers(date)) <
        parseInt(formatDateOnlyNumbers(new Date()))
      ) {
        this.show_justification = true;
      }
    },
    // Migrado para o estoque novo
    async getStocksByMedicine() {
      try {
        const { medicines_check, resident_id } = this;

        let separateMedicines = [];
        for (let medicine of medicines_check) {
          separateMedicines.push({
            medicine_id: medicine.prescription_medicine.medicine_id,
            stocked_item_id: medicine.medicine_check.stocked_item_id,
          });
        }

        let params = { resident_id, medicines: separateMedicines };

        const response = await api.post(
          "/rest-home/resident/medicine-check/stock-by-separate-multiple",
          params
        );

        const { error, errors, medicines } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.medicines = medicines;
          this.errors = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleNotDone() {
      this.checked = "NAO";
      this.despised = false;
    },
    handleDone() {
      this.checked = "SIM";
      this.despised = false;
      this.note = "";
    },
    handlePrev() {
      let { step } = this;

      if (step == 2) {
        this.step = step - 1;
      }
    },
    handleNext() {
      let { step, note, checked } = this;

      if (step == 1) {
        if (!checked) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe se foi REALIZADO ou NÃO REALIZADO",
            },
          ];
          return;
        }

        if (checked == "NAO") {
          if (!String(note).trim() || !note) {
            this.errors = [
              {
                id: this.errors.length,
                message: "Informe o motivo",
              },
            ];
            return;
          }
        }

        this.errors = [];
        this.step = step + 1;
      }

      if (step == 2) {
        this.check();
        return;
      }
    },
    async check() {
      try {
        this.loading = true;

        let {
          resident_id,
          medicines_check,
          stock_id,
          checked,
          note,
          despised,
          date,
          show_justification,
          justification,
          medicines,
        } = this;

        let params = {
          resident_id,
          medicines_check,
          stock_id,
          checked,
          note,
          despised,
          date,
          justification,
          medicines,
        };

        if (show_justification) {
          if (!justification || !String(justification).trim()) {
            this.errors = [
              { id: this.errors, message: "Informe a justificativa" },
            ];
            this.loading = false;
            return;
          }
        }

        const response = await api.post(
          "/rest-home/check/check-multiple",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`modalCheckedSelected_${this.check_time}`);
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleSerasa() {
      let {
        resident_id,
        medicine_check: { id },
        stock_id,
        checked,
        note,
        despised,
        date,
      } = this;

      if (!note) {
        note = null;
      }

      window.open(
        `http://serasa-clin.sa-east-1.elasticbeanstalk.com/serasa/?redirect_to=https://portal.sistemaclin.com.br/serasa/check/confirm/${id}/${stock_id}/${checked}/${note}/${despised}/${date}/${resident_id}`,
        "Ratting",
        "width=550,height=550,left=150,top=200,toolbar=1,status=1,"
      );
    },
  },
};
</script>
